// src/components/SignIn.jsx
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  auth,
  login,
  selectAuthLoading,
  selectAuthError,
} from "../store/authSlice";
import {
  fetchEquipment,
  fetchInfoData,
  fetchChartData,
} from "../store/informationSlice";
import { toast } from "react-toastify";

export default function SignIn() {
  const dispatch = useDispatch();
  const loading = useSelector(selectAuthLoading);
  const error = useSelector(selectAuthError);

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await dispatch(
        login({ account: username, password, remember })
      ).unwrap();
      if (res.login === 1) {
        // 🔑 登入成功後補拉資料
        toast.success("登入成功", {
          position: "top-center",
        });
        dispatch(auth()).unwrap();
        dispatch(fetchEquipment());
        dispatch(fetchInfoData());
        dispatch(fetchChartData({ type: 1, equipment_id: 1 }));
      }
    } catch (err) {
      console.log("登入失敗");
    }
  };

  return (
    <div
      className="flex items-center justify-center min-h-screen bg-cover bg-no-repeat bg-center px-4"
      style={{ backgroundImage: "url('/assets/images/ems-bg.png')" }}
    >
      <form
        onSubmit={handleSubmit}
        className="p-6 md:p-8 lg:p-10 w-fit flex flex-col gap-4 items-center justify-center"
      >
        {/* Logo 與標題 */}
        <div
          className="flex flex-col items-center justify-center gap-2 bg-cover bg-no-repeat bg-center w-[320px] h-[320px] lg:w-[465px] lg:h-[465px]"
          style={{ backgroundImage: "url('/assets/images/looper-line.png')" }}
        >
          <div className="mt-14 lg:w-[420px] lg:h-[182px] flex flex-col justify-center items-center gap-2">
            <img
              src="/assets/logo/logo512.png"
              alt="EMS Logo"
              className="w-[88px] h-[88px] lg:w-[120px] lg:h-[120px]"
            />
            <h3 className="w-full text-center font-semibold text-[24px] lg:text-[36px] tracking-[14px] lg:tracking-[20px] text-[#66E6F9]">
              EMS System
            </h3>
          </div>
        </div>

        <div className="flex flex-col gap-4 w-full p-2 lg:w-[500px]">
          {/* 帳號輸入 */}
          <div className="relative w-full">
            <span className="absolute inset-y-0 left-4 flex items-center pointer-events-none">
              <img
                src="/assets/icons/login-user.svg"
                alt="User Icon"
                className="w-5 h-5 text-gray-400"
              />
            </span>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="使用者名稱"
              className="w-full h-[60px] pl-12 pr-4 rounded-[12px] border border-gray-300 bg-transparent text-[#9A9797] placeholder-[#9A9797] focus:outline-none focus:ring-2 focus:ring-[#2F31A2]"
              disabled={loading}
            />
          </div>

          {/* 密碼輸入 */}
          <div className="relative w-full">
            <span className="absolute inset-y-0 left-4 flex items-center pointer-events-none">
              <img
                src="/assets/icons/login-password.svg"
                alt="Password Icon"
                className="w-5 h-5 text-gray-400"
              />
            </span>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="輸入密碼"
              className="w-full h-[60px] pl-12 pr-4 rounded-[12px] border border-gray-300 bg-transparent text-[#9A9797] placeholder-[#9A9797] focus:outline-none focus:ring-2 focus:ring-[#2F31A2]"
              disabled={loading}
            />
          </div>

          {/* 記住我 */}
          <div className="flex justify-start">
            <label className="inline-flex items-center gap-2 text-white">
              <input
                type="checkbox"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
                className="h-5 w-5 rounded border border-white/40 bg-[#2F293E] focus:outline-none focus:ring-2 focus:ring-[#2F31A2]"
                disabled={loading}
              />
              <span className="select-none">記住我</span>
            </label>
          </div>

          {/* 錯誤訊息 */}
          {error && error !== "尚未登入" && (
            <p className="text-red-500 text-center">{error}</p>
          )}
        </div>

        {/* 登入按鈕 */}
        <button
          type="submit"
          disabled={loading}
          className="mt-8 mr-auto w-[220px] h-[58px] bg-[#66E6F9] flex items-center justify-center gap-[40px] text-black text-[20px] hover:opacity-65 rounded-[12px] transition-opacity duration-300 disabled:opacity-50"
        >
          {loading ? "登入中..." : "登入"}
          <img
            src="/assets/icons/login-arrow.svg"
            alt="登入"
            className="w-6 h-6"
          />
        </button>
      </form>
    </div>
  );
}
